import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch } from "vue";

import Toast from "primevue/toast";
import { useToast } from "primevue/usetoast";

import commonStore from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationComponent',
  setup(__props) {

const toast = useToast();
const store = commonStore();

watch(
  () => store.toastGlobalState,
  () => {
    show(store.toastGlobalMessage);
  }
);

function show(msg: string) {
  toast.add({
    severity: store.toastGlobalSeverity || "error",
    summary: store.toastGlobalHead || "Ошибка",
    detail: msg || "Обратитесь в департамент разработки.",
    group: "br",
    life: 5000,
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Toast), {
      position: "bottom-right",
      group: "br"
    })
  ]))
}
}

})